import React from 'react';
import {
  Container,
  Col,
  Row
} from 'react-bootstrap';
import { FaReact } from 'react-icons/fa';
export default function FooterSite(){
    return (
        <div className='text-center p-1' style={{ backgroundColor: 'rgba(85, 26, 139, 0.8)' , color: 'rgba(255,255,255,0.5)'}}>
      <Container>
        <Row>
          <Col className='float-right d-block w-50'>
            <p>
              Made in <FaReact /> React
            </p>
            <p>
              Database version : <b>2020_01</b>
            </p>
            <p>
              Website version : <b>Beta</b>
            </p>
          </Col>
          <Col>
          </Col>
        </Row>
        <Row>
            <div>
            &copy; {new Date().getFullYear()}  {'   '}
            <a className='text-white' href='https://www.cicese.edu.mx/'>
              CICESE
            </a>
            </div>
        </Row>
      </Container>
        
      </div>
      );
}